import {
  UsersIcon,
  UserPlusIcon,
  ChartBarIcon,
  MegaphoneIcon,
  ArrowUpTrayIcon,
  WrenchScrewdriverIcon,
  UserGroupIcon,
  EyeSlashIcon,
  MapPinIcon,
  ClockIcon,
  DocumentArrowUpIcon,
  HomeModernIcon,
  Squares2X2Icon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Dashboard",
    href: "/stochastic",
    icon: Squares2X2Icon, // Changed from ChartBarIcon to Squares2X2Icon
    current: false,
    internalName: "dashboard",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"]
  },
  {
    name: "Prospects",
    href: "/stochastic/prospects",
    icon: UserPlusIcon, // Changed from EyeIcon to UserPlusIcon
    current: false,
    internalName: "prospects",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Customers",
    href: "/stochastic/customers",
    icon: UserGroupIcon, // Changed from UsersIcon to UserGroupIcon
    current: false,
    internalName: "customers",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Invoices",
    href: "/stochastic/invoices",
    icon: DocumentTextIcon,
    current: false,
    internalName: "invoices",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Locations",
    href: "/stochastic/locations",
    icon: MapPinIcon, // Kept MapPinIcon - perfect for locations
    current: false,
    internalName: "locations",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Campaign Management",
    href: "/stochastic/campaigns",
    icon: MegaphoneIcon, // Kept MegaphoneIcon - perfect for campaigns
    current: false,
    internalName: "campaigns",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_OWNER_GM", "ROLE_MARKETING"],
  },
  {
    name: "Uploads",
    href: "#",
    icon: ArrowUpTrayIcon, // Kept ArrowUpTrayIcon - perfect for uploads
    current: false,
    internalName: "dashboards",
    roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
    children: [
      {
        name: "Field Service Import",
        href: "/stochastic/field-service-import",
        icon: WrenchScrewdriverIcon, // Changed from PlusIcon to WrenchScrewdriverIcon
        current: false,
        internalName: "field_service_import",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
      },
      {
        name: "Prospect Source Import",
        href: "/stochastic/prospect-source-import",
        icon: UserPlusIcon, // Changed from PlusIcon to UserPlusIcon
        current: false,
        internalName: "prospect_source_import",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
      },
      {
        name: "Do Not Mail Import",
        href: "/stochastic/do-not-mail-import",
        icon: EyeSlashIcon, // Changed from PlusIcon to EyeSlashIcon
        current: false,
        internalName: "do_not_mail_import",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
      },
      {
        name: "Import Status",
        href: "/stochastic/import-status",
        icon: ClockIcon, // Changed from PlusIcon to ClockIcon
        current: false,
        internalName: "import_status",
        roles: ["ROLE_SUPER_ADMIN", "ROLE_MARKETING"],
      },
    ],
  },
];

const stochasticConfig = {
  sectionName: "stochastic",
  defaultRoute: "/stochastic",
  navigation,
};

export default stochasticConfig;
